import axios from "axios";
import { getRefreshToken, setTokens, clearTokens } from "./authTokenStore";

export async function refreshToken() {
  const refresh = getRefreshToken();
  if (!refresh) throw new Error("No refresh token");

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/token/refresh/`, 
      { refresh }
    );
    setTokens({ access: res.data.access, refresh });
    return res.data.access;
  } catch (err) {
    clearTokens();
    throw err;
  }
}